import { isEqual } from 'lodash/fp'
import { PollCreate, Post } from '@wellesley/openapi'

import {
  DEFAULT_POLL_OPTIONS,
  DEFAULT_POLL_MULTIPLE,
  DEFAULT_POLL_EXPIRES_IN,
} from '../../CreatePollSection/helpers'

const comparePoll = (pollData: PollCreate | null, feed?: Post) => {
  if (!pollData && !feed?.poll) return false

  const isOptionsChanged = !isEqual(
    pollData?.options || [],
    feed?.poll?.options.map((v) => v.title) || DEFAULT_POLL_OPTIONS,
  )
  const isChangedType =
    pollData?.multiple !== (feed?.poll?.multiple ?? DEFAULT_POLL_MULTIPLE)

  const isDurationChanged = pollData?.expiresIn !== DEFAULT_POLL_EXPIRES_IN

  return isChangedType || isOptionsChanged || isDurationChanged
}

export default comparePoll
